// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Logo_wrapper__3bXRL","logo":"Logo_logo__wWTpy"};